<template>
  <div v-if="brands && brands.length" class="brands sides-padding">
    <div class="container">
      <div class="brands__container">
        <h2 class="brands__title main-color">Популярные бренды</h2>
        <div class="brands__list">
          <BrandComponent v-for="(item, i) in brands" :key="i" :data="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BrandComponent from "components/brands/BrandComponent.vue";

export default {
  name: "BrandsComponent",
  components: { BrandComponent },
  props: {
    brands: Array,
  },
};
</script>

<style lang="stylus">
.brands {
  display flex
  justify-content center
  padding 0 15px

  &__container {
    display flex
    flex-direction column
    align-items center
    justify-content flex-start
    gap 30px
  }

  &__title {
    display: flex;
    align-items: center;
    margin 0
  }

  &__list {
    display grid
    grid-template-columns repeat(8, 1fr)
    grid-gap 24px
    width: 100%;
    +below(1024px) {
      grid-template-columns repeat(7, 1fr)
    }
    +below(940px) {
      grid-template-columns repeat(6, 1fr)
    }
    +below(860px) {
      grid-template-columns repeat(5, 1fr)
    }
    +below(680px) {
      grid-template-columns repeat(4, 1fr)
    }
    +below(540px) {
      grid-template-columns repeat(3, 1fr)
      grid-gap 15px
    }
  }
}
</style>
